import {Component, inject, NgZone, OnInit, ViewChild} from '@angular/core';
import {BaseComponentWithDrawer} from "../base-component-with-drawer.component";
import {GetUsersCB} from "../../../ope/user/GetUsersCB";
import {UserOpeService} from "../../../services/ope/userOpe.service";
import {User} from "../../../models/user/User";
import {GlobalModelService} from "../../../services/GlobalModel.service";
import {PartitionOpeService} from "../../../services/ope/partitionOpe.service";
import {
  DxDateBoxComponent,
  DxFormComponent,
  DxTreeListComponent,
  DxValidationGroupComponent,
} from "devextreme-angular";
import {Partition} from "../../../models/partition/Partition";
import {PutUserCB} from "../../../ope/user/PutUserCB";
import {DelUserCB} from "../../../ope/user/DelUserCB";
import {DxTextBoxTypes} from 'devextreme-angular/ui/text-box';
import {SpringRestService} from "@aiknow-srl/aik-ngx-http";
import {UpdateUserPartitionCB} from "../../../ope/user/UpdateUserPartitionCB";
import {SelectionChangedEvent} from "devextreme/ui/tree_list";
import {GetPartitionHierarchyCB} from "../../../ope/partition/GetPartitionHierarchyCB";
import {GetExternalApplicationCB} from "../../../ope/external-application/GetExternalApplicationCB";
import {ExternalApplicationOpeService} from "../../../services/ope/externalApplicationOpe.service";
import {ExternalApplication} from "../../../models/external-application/ExternalApplication";
import {DelExternalApplicationCB} from "../../../ope/external-application/DelExternalApplicationCB";
import {PutExternalApplicationCB} from "../../../ope/external-application/PutExternalApplicationCB";
import {ApiConfig} from "../../../models/external-application/ApiConfig";
import {ChangeExternalApplicationSecretCB} from "../../../ope/external-application/ChangeExternalApplicationSecretCB";
import {Logs} from "../../../models/external-application/Logs";
import {
  GetExternalApplicationApiCallsLogCB
} from "../../../ope/external-application/GetExternalApplicationApiCallsLogCB";
import DevExpress from "devextreme";
import ValidationRule = DevExpress.common.ValidationRule;
import {UpdateExternalApplicationCB} from "../../../ope/external-application/UpdateExternalApplicationPartitionCB";
import {AuthOpeService} from "../../../services/ope/authOpe.service";
import {ImpersonateUserCB} from "../../../ope/auth/ImpersonateUserCB";
import {RevokeUserSessionsCB} from "../../../ope/auth/RevokeUserSessionsCB";
import {GrpcAuthorizationOPEService} from "../../../services/ope/grpc/authorizationOPE.service";
import {SendUserWelcomeEmailCB} from "../../../ope/user/SendUserWelcomeEmailCB";
import {ResetPasswordCB} from "../../../ope/auth/ResetPasswordCB";

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.css', '../../common/drawer-style.css', '../base-component-with-drawer.component.css']
})
export class UserComponent extends BaseComponentWithDrawer implements OnInit {

  gmService: GlobalModelService = inject(GlobalModelService);
  partitionService: PartitionOpeService = inject(PartitionOpeService);
  userService: UserOpeService = inject(UserOpeService);
  authenticationOpeService: AuthOpeService = inject(AuthOpeService);
  authorizationOPEService: GrpcAuthorizationOPEService = inject(GrpcAuthorizationOPEService);
  private ngZone = inject(NgZone);
  externalApplicationService: ExternalApplicationOpeService = inject(ExternalApplicationOpeService);
  @ViewChild('newUserForm', {static: false}) newUserForm!: DxFormComponent;
  @ViewChild('newUserPartitionTree', {static: false}) newUserPartitionTree!: DxTreeListComponent;
  @ViewChild('newExternalApplicationForm', {static: false}) newExternalApplicationForm!: DxFormComponent;
  @ViewChild('editUserForm', {static: false}) editUserForm!: DxFormComponent;
  @ViewChild('editExternalApplicationForm', {static: false}) editExternalApplicationForm!: DxFormComponent;
  @ViewChild(DxValidationGroupComponent, {static: false}) validationGroup?: DxValidationGroupComponent;
  @ViewChild('dateFromBox', {static: false}) dateFromBox?: DxDateBoxComponent;
  @ViewChild('dateToBox', {static: false}) dateToBox?: DxDateBoxComponent;

  /**
   * All partitions
   */
  partitions: Partition[] = [];
  /**
   * All partitions without the user partition, used by linked partition tab
   */
  linkedPartitionsFiltered: Partition[] = [];
  /**
   * All selected partition users
   */
  users: User[] = [];
  /**
   * All selected partition external applications
   */
  externalApplications: ExternalApplication[] = [];
  /**
   * All selectable roles
   */
  roles: string[] = [];
  /**
   * Partitions tab for adding/editing a partition
   */
  newUserTabs: any[] = [
    {
      id: 0,
      text: "Utente"
    },
    {
      id: 1,
      text: "Ruoli"
    },
    {
      id: 2,
      text: "Partizione"
    }
  ];
  /**
   * Partitions tab for adding/editing a partition
   */
  editUserTabs: any[] = [
    {
      id: 0,
      text: "Utente"
    },
    {
      id: 1,
      text: "Ruoli"
    },
    {
      id: 2,
      text: "Partizioni collegate"
    }
  ];
  selectedPartition?: Partition;
  /**
   * Selected user on tree list row click
   */
  selectedUser?: User;
  /**
   * Copy of selected user, storing temporary changes (can roll back to selectedUser if something goes wrong)
   */
  editedUser?: User;
  /**
   * New user used when opening new user form
   */
  newUser?: User = new User();
  /**
   * Selected external application on tree list row click
   */
  selectedExternalApplication?: ExternalApplication;
  selectedExternalApplicationApiConfigMapKeys?: string[];
  selectedExternalApplicationApiCallLogs: Logs[] = [];
  /**
   * Copy of selected external application, storing temporary changes (can roll back to selectedExternalApplication if something goes wrong)
   */
  editedExternalApplication?: ExternalApplication;
  /**
   * New external application used when opening new external application form
   */
  newExternalApplication?: ExternalApplication;
  /**
   * Show lateral drawer when true
   */
  isDrawerOpen = false;
  /**
   * Enable lateral drawer form when true
   */
  isEditMode: boolean = false;
  /**
   * Selection mode for linked partitions tree list
   */
  selectionMode: 'single' | 'multiple' | 'none' = 'none';
  /**
   * Tab selected partition form (new/edit)
   */
  selectedUserTab: number = 0;
  /**
   * Open new user dialog when true
   */
  addUser: boolean = false;
  /**
   * Open new external application dialog when true
   */
  addExternalApplication: boolean = false;
  /**
   * Open delete user dialog when true
   */
  deletingUser: boolean = false;
  sendingWelcomeEmail: boolean = false;
  resettingPassword: boolean = false;
  revokingSessions: boolean = false;
  /**
   * Open delete externalApplication dialog when true
   */
  deletingExternalApplication: boolean = false;
  /**
   * True if the user changed anything in edit partition form
   */
  userEdited: boolean = false;
  /**
   * Triggers change secret key popup visibility
   */
  changingSecretKey: boolean = false;
  /**
   * True if the user changed anything in edit partition form
   */
  externalApplicationEdited: boolean = false;
  /**
   * show change parent partition form when true
   */
  editUserPartition: boolean = false;
  /**
   * show change parent partition form when true
   */
  editExternalApplicationPartition: boolean = false;
  /**
   * True if new partition is valid and can be saved
   */
  isNewFormValid: boolean | undefined = false;
  /**
   * True if edited partition is valid and can be updated
   */
  isEditFormValid: boolean | undefined = false;
  /**
   * Id of the selected partition in the main tree list (selected by clicking on a row)
   */
  selectedRowPartitions: any;
  /**
   * Id of the selected user in the user data grid (selected by clicking on a row)
   */
  selectedRowUser: any;
  /**
   * Id of the selected external application in the user data grid (selected by clicking on a row)
   */
  selectedRowExternalApplication: any;
  /**
   * Id of the selected user in the new user form tree list (selected by clicking on a row)
   */
  selectedRowNewUserForm: any;
  /**
   * Id of the selected external application in the new external application form tree list (selected by clicking on a row)
   */
  selectedRowNewExternalApplicationForm: any;
  /**
   * Id of the selected partition in the change parent partition form tree list (selected by clicking on a row)
   */
  selectedRowEditUserPartitionForm: any;
  /**
   * Id of the selected partition in the change parent partition form tree list (selected by clicking on a row)
   */
  selectedRowEditExternalApplicationPartitionForm: any;
  /**
   * Password mode for password input field
   */
  passwordMode: DxTextBoxTypes.TextBoxType = 'password';
  /**
   * Selected partition row in new user form
   */
  selectedRowPartitionNewUserForm: any;
  /**
   * Selected partition row in new external application form
   */
  selectedRowPartitionNewExternalApplicationForm: any;
  selectedRowLinkedPartitionsOfUser?: any[] = [];
  selectedRowLinkedPartitionsOfExternalApplication?: any[] = [];
  apiConfigOptions?: { key: string; name: string }[];
  /**
   * Selected api key for logging api calls of selected external application
   */
  selectedApiKey?: string;
  /**
   * Start of the date range filter for api calls log (midnight of today)
   */
  apiLogsDateFrom: string | number | Date = new Date(new Date().setHours(0, 0, 0, 0));
  /**
   * End of the date range filter for api calls log (midnight of tomorrow)
   */
  apiLogsDateTo: string | number | Date = new Date(new Date().setHours(24, 0, 0, 0));
  /**
   * Text box options for partition fields
   */
  userNewTextOptions = {
    valueChangeEvent: 'keyup'
  };
  userPasswordOptions = {
    valueChangeEvent: 'keyup',
    mode: this.passwordMode,
    buttons: [
      {
        name: 'password',
        location: 'after',
        options: {
          icon: 'eyeopen',
          stylingMode: 'text',
          onClick: () => {
            this.passwordMode = this.passwordMode === 'text' ? 'password' : 'text';
            this.updatePasswordMode();
          },
        }
      }
    ]
  };


  userNewTextAreaOptions = {
    valueChangeEvent: 'keyup',
    autoResizeEnabled: true
  };
  userEditTextOptions = {
    valueChangeEvent: 'keyup',
    disabled: !this.isEditMode
  };
  userEditPasswordOptions = {
    valueChangeEvent: 'keyup',
    disabled: !this.isEditMode,
    mode: this.passwordMode,
    buttons: [
      {
        name: 'password',
        location: 'after',
        options: {
          icon: 'eyeopen',
          stylingMode: 'text',
          onClick: () => {
            this.passwordMode = this.passwordMode === 'text' ? 'password' : 'text';
            this.updateEditPasswordMode();
          },
        }
      }
    ]
  };
  userEditTextAreaOptions = {
    valueChangeEvent: 'keyup',
    disabled: !this.isEditMode,
    autoResizeEnabled: true
  };
  userEditCheckBoxOptions = {
    disabled: !this.isEditMode
  };
  userEditSwitchOptions = {
    disabled: !this.isEditMode
  };

  externalApplicationNewSwitchOptions = {
    switchedOnText: 'ON',
    switchedOffText: 'OFF',
    valueChangeEvent: 'keyup',
  };

  externalApplicationEditSwitchOptions = {
    switchedOnText: 'ON',
    switchedOffText: 'OFF',
    valueChangeEvent: 'keyup',
    disabled: !this.isEditMode
  };

// Editor options for number box
  requestLimitEditOptions = {
    min: 0,
    showSpinButtons: true,
    valueChangeEvent: 'keyup',
    disabled: !this.isEditMode
  };

  // Editor options for number box
  arraySizeEditOptions = {
    min: 0,
    placeholder: 0,
    showSpinButtons: true,
    valueChangeEvent: 'keyup',
    disabled: !this.isEditMode,
  };

  // Editor options for number box
  requestLimitNewOptions = {
    min: 0,
    showSpinButtons: true,
    valueChangeEvent: 'keyup',
  };

  arraySizeNewOptions = {
    min: 0,
    placeholder: 0,
    showSpinButtons: true,
    valueChangeEvent: 'keyup',
  };

  externalApplicationNewTextOptions = {
    valueChangeEvent: 'keyup',
  };

  externalApplicationEditTextOptions = {
    valueChangeEvent: 'keyup',
    disabled: !this.isEditMode
  };

  noDataText: string = '';
  protected be = inject(SpringRestService);

  rolesCellTemplate = (cellElement: any, cellInfo: any) => {
    cellElement.innerText = this.translate.instant("REGISTRY.USER.ROLES_NAME." + cellInfo.data);
  };

  ngOnInit() {
    super.ngOnInit();
    this.getPartitions();
    this.getDefaultApiNames();
    this.roles = this.gmService.rolesList;
  }

  protected newExternalApplicationApiConfig?: Record<string, ApiConfig> | null;

  /**
   * Get all partitions
   */
  getPartitions() {
    const cb = new GetPartitionHierarchyCB();

    this.partitionService.getPartitionHierarchy(cb).then((_) => {

      this.partitions = cb.o.partitions;

    }).catch((error) => {
      if (!!this.selectedUser)
        this.editedUser = JSON.parse(JSON.stringify(this.selectedUser));
    });
  }

  /**
   * Get all users of a specified partition
   */
  getUsers() {

    const cb = new GetUsersCB();

    cb.i.partitionId = this.selectedPartition!.id;

    this.userService.getUsers(cb).then((_) => {

      this.users = cb.o.users;

      // if the drawer was already open, update the infos (probably a user has been updated)
      if (!!this.selectedUser) {
        this.selectedUser = this.users.find(u => u.id === this.selectedUser?.id);
        if (!!this.selectedUser) {
          this.editedUser = JSON.parse(JSON.stringify(this.selectedUser));
          this.selectedRowLinkedPartitionsOfUser = this.editedUser?.linkedPartitions;
        } else {
          this.isDrawerOpen = false;
          this.selectedRowUser = [];
        }
      }

    });

  }

  /**
   * Send the welcome email (with password-set link) to a user who hasn't set their password yet
   */
  sendWelcomeEmail(user: User) {

    // close send welcome email dialog
    this.sendingWelcomeEmail = false;

    const cb = new SendUserWelcomeEmailCB();

    cb.i.userId = user.id;
    cb.i.baseFeUrl = this.gmService.composeBaseFEUrl();
    cb.i.action = this.appService.PASSWORD_RESET_ACTION;

    this.userService.sendUserWelcomeEmail(cb).then((_) => {
      this.toastService.openSuccessToastMessage(this.translate.instant("REGISTRY.USER.TEXT.WELCOME_EMAIL_SENT"));
    });
  }

  /**
   * Send the reset password email to a user who already set their password
   */
  resetUserPassword(user: User) {

    // close reset password dialog
    this.resettingPassword = false;

    const cb = new ResetPasswordCB();

    cb.i.email = user.email;
    cb.i.baseFeUrl = this.gmService.composeBaseFEUrl();
    cb.i.action = this.appService.PASSWORD_RESET_ACTION;

    this.authenticationOpeService.resetPassword(cb).then((_) => {
      this.toastService.openSuccessToastMessage(this.translate.instant("REGISTRY.USER.TEXT.RESET_PASSWORD_EMAIL_SENT"));
    });
  }

  /**
   * Revoke every active session of a user: they must log in again once their current access token expires
   */
  revokeUserSessions(user: User) {

    this.revokingSessions = false;

    const cb = new RevokeUserSessionsCB();
    cb.i.userId = user.id;

    this.authenticationOpeService.revokeUserSessions(cb).then((_) => {
      this.toastService.openSuccessToastMessage(this.translate.instant("REGISTRY.USER.TEXT.SESSIONS_REVOKED"));
    });
  }

  /**
   * Get all external applications of a specified partition
   */
  getExternalApplications() {

    const cb = new GetExternalApplicationCB();

    cb.i.partitionId = this.selectedPartition!.id;

    this.externalApplicationService.getExternalApplication(cb).then((_) => {

      this.externalApplications = cb.o.externalApplications;

      // if the drawer was already open, update the infos (probably a user has been updated)
      if (!!this.selectedExternalApplication) {
        this.selectedExternalApplication = this.externalApplications.find(e => e.id === this.selectedExternalApplication?.id);
        if (!!this.selectedExternalApplication) {
          this.editedExternalApplication = JSON.parse(JSON.stringify(this.selectedExternalApplication));
          this.selectedRowLinkedPartitionsOfUser = this.editedExternalApplication?.linkedPartitions;
        } else {
          this.isDrawerOpen = false;
          this.selectedRowExternalApplication = [];
        }
      }

    });

  }

  getExternalApplicationApiCallsLog(selectedApiEndpoint: string | undefined, apiLogsDateFrom: string | number | Date, apiLogsDateTo: string | number | Date) {

    const cb = new GetExternalApplicationApiCallsLogCB();

    cb.i.partitionId = this.selectedPartition!.id;
    if (!!this.selectedExternalApplication?.id) {
      cb.i.applicationId = this.selectedExternalApplication?.id;
    }
    if (!!selectedApiEndpoint) {
      cb.i.endpoint = selectedApiEndpoint;
    }
    if (!!apiLogsDateFrom) {
      cb.i.from = new Date(apiLogsDateFrom);
    }
    if (!!apiLogsDateTo) {
      cb.i.to = new Date(apiLogsDateTo);
    }


    this.externalApplicationService.getExternalApiCallsLog(cb).then((_) => {
      if (!!cb.o.logs) {
        this.selectedExternalApplicationApiCallLogs = cb.o.logs;
      }
    });

  }

  /**
   * Add or update user
   */
  putUser(user: User | undefined) {

    let hashedPassword;

    if (!!user!.password) {
      hashedPassword = this.be.hashPassword(user!.password);
    }

    // create cb
    const cb = new PutUserCB();
    cb.i.id = user!.id;

    if (!!this.selectedPartition) {
      cb.i.partitionId = this.selectedPartition.id;
    }
    cb.i.username = user!.username;
    cb.i.password = hashedPassword;
    cb.i.email = user!.email;
    cb.i.language = user?.language;
    cb.i.firstname = user!.firstname;
    cb.i.lastname = user!.lastname;
    cb.i.roles = user!.roles!;
    cb.i.linkedPartitions = user?.linkedPartitions;
    cb.i.enabled = user!.enabled;
    cb.i.welcomeSent = user!.welcomeSent ?? false;

    this.userService.putUser(cb).then((_) => {
      this.addUser = false;

      this.isNewFormValid = false;

      if (!user!.id)
        this.toastService.openSuccessToastMessage(this.translate.instant("REGISTRY.USER.TEXT.CREATED"));
      else
        this.toastService.openSuccessToastMessage(this.translate.instant("REGISTRY.USER.TEXT.UPDATED"));

      // reload users list
      if (!!this.selectedPartition) {
        this.getUsers();
        this.getExternalApplications();
      }
    }).catch((error) => {

      // roll back to previous user version
      if (!!this.selectedUser)
        this.editedUser = JSON.parse(JSON.stringify(this.selectedUser));
    });
  }

  /**
   * Add or update externalApplication
   */
  putExternalApplication(externalApplication: ExternalApplication | undefined) {

    // create cb
    const cb = new PutExternalApplicationCB();
    if (!!externalApplication) {
      if (!!externalApplication.id) {
        cb.i.id = externalApplication.id;
      }
      if (!!this.selectedPartition) {
        cb.i.partitionId = this.selectedPartition.id;
      }
      cb.i.email = externalApplication.email;
      cb.i.description = externalApplication.description;
      cb.i.language = externalApplication.language;
      cb.i.enabled = externalApplication.enabled;
      cb.i.apiConfigMap = externalApplication.apiConfigMap;
      cb.i.linkedPartitions = externalApplication.linkedPartitions
    }

    this.externalApplicationService.putExternalApplication(cb).then((_) => {
      this.addExternalApplication = false;

      this.isNewFormValid = false;

      if (!externalApplication!.id)
        this.toastService.openSuccessToastMessage(this.translate.instant("REGISTRY.EXTERNAL_APPLICATION.TEXT.CREATED"));
      else
        this.toastService.openSuccessToastMessage(this.translate.instant("REGISTRY.EXTERNAL_APPLICATION.TEXT.UPDATED"));

      // reload users list
      if (!!this.selectedPartition) {
        this.getUsers();
        this.getExternalApplications();
      }
    }).catch((error) => {

      // roll back to previous user version
      if (!!this.selectedExternalApplication)
        this.editedExternalApplication = JSON.parse(JSON.stringify(this.selectedExternalApplication));
    });
  }

  /**
   * Get users of a partition when clicking on the partition tree list row (only if the event is not a click on the arrow to open the children)
   * @param $event
   */
  onPartitionRowClick($event: any) {
    if (!($event.event.target.parentElement.classList.contains("dx-treelist-expanded") || $event.event.target.parentElement.classList.contains("dx-treelist-collapsed"))) {
      if (!this.selectedPartition || this.selectedPartition.id !== $event.data.id) {
        this.closeDrawerAndReset();
        this.selectedPartition = $event.data;
        this.selectedRowPartitions = [$event.data.id];
        this.getUsers();
        this.getExternalApplications();
      } else {

        this.selectedPartition = undefined;
        this.selectedRowPartitions = undefined;
        this.selectedRowUser = undefined;

        this.closeDrawerAndReset();
      }
    }
  }


  /**
   * Close drawer and reset vars
   */
  closeDrawerAndReset() {
    this.closeDrawer();

    this.resetDrawer();
  }

  /**
   * Close lateral drawer
   */
  closeDrawer() {
    if (this.isEditMode && (this.userEdited || this.externalApplicationEdited)) {
      this.showDiscardEditsDialog().show().done((dialogResult: any) => {
        if (dialogResult) {
          this.resetDrawer();
          this.isDrawerOpen = false;
          this.selectedUserTab = 0;
          this.resetUserGrid();
          this.resetExternalApplicationGrid();
        }
      });
    } else {
      this.resetDrawer();
      this.isDrawerOpen = false;
      this.selectedUserTab = 0;
      this.resetUserGrid();
      this.resetExternalApplicationGrid();
    }
  }

  resetUserGrid() {
    this.selectedUser = undefined;
    this.editedUser = undefined;
    this.selectedRowUser = [];
  }

  resetExternalApplicationGrid() {
    this.selectedExternalApplication = undefined;
    this.editedExternalApplication = undefined;
    this.selectedRowExternalApplication = [];
  }

  /**
   * Reset all drawer vars
   */
  resetDrawer() {
    if (!!this.selectedUser) {
      this.editedUser = JSON.parse(JSON.stringify(this.selectedUser));
      this.selectedRowLinkedPartitionsOfUser = this.editedUser?.linkedPartitions;

      this.userEdited = false;
      this.selectionMode = 'none';
      this.isEditMode = false;
      this.updateUserTextOptions();
    }

    if (!!this.selectedExternalApplication) {
      this.editedExternalApplication = JSON.parse(JSON.stringify(this.selectedExternalApplication));
      this.selectedRowLinkedPartitionsOfExternalApplication = this.editedExternalApplication?.linkedPartitions;
      this.selectedExternalApplicationApiCallLogs = []
      this.externalApplicationEdited = false;
      this.selectionMode = 'none';
      this.isEditMode = false;
      this.updateUserTextOptions();

    }

  }

  /**
   * Open drawer when clicking on a tree list row (only if the event is not a click on the arrow to open the children)
   * @param $event
   */
  onUserRowClick($event: any) {
    if (!this.selectedUser) {
      if (!!this.selectedExternalApplication) {
        this.closeDrawer();
      }
      this.selectedUser = $event.data;
      this.editedUser = JSON.parse(JSON.stringify(this.selectedUser));
      this.selectedRowLinkedPartitionsOfUser = this.editedUser?.linkedPartitions;
      this.linkedPartitionsFiltered = this.partitions.filter(p => p.id !== this.selectedPartition?.id);
      this.isDrawerOpen = true;
    } else {
      if (this.selectedUser!.id === $event.data.id) {
        this.closeDrawer();
      } else {
        this.switchUser($event.data);
      }
    }
  }

  /**
   * Open drawer when clicking on a tree list row (only if the event is not a click on the arrow to open the children)
   * @param $event
   */
  onExternalApplicationRowClick($event: any) {
    if (!this.selectedExternalApplication) {
      if (!!this.selectedUser) {
        this.closeDrawer();
      }
      this.selectedExternalApplication = $event.data;
      this.selectedApiKey = undefined;
      this.apiLogsDateFrom = new Date(new Date().setHours(0, 0, 0, 0));
      this.apiLogsDateTo = new Date(new Date().setHours(24, 0, 0, 0));
      this.editedExternalApplication = JSON.parse(JSON.stringify(this.selectedExternalApplication));
      if (this.editedExternalApplication?.apiConfigMap) {
        this.selectedExternalApplicationApiConfigMapKeys = Object.keys(this.editedExternalApplication.apiConfigMap);
        if (this.selectedExternalApplicationApiConfigMapKeys && this.gmService.eaApiConfigMapDefault) {
          this.apiConfigOptions = this.selectedExternalApplicationApiConfigMapKeys.map(key => ({
            key: key,
            name: this.gmService.eaApiConfigMapDefault![key]?.name || key
          }));
        }
      }
      this.selectedRowLinkedPartitionsOfExternalApplication = this.editedExternalApplication?.linkedPartitions;
      this.linkedPartitionsFiltered = this.partitions.filter(p => p.id !== this.selectedPartition?.id);
      this.isDrawerOpen = true;
    } else {
      if (this.selectedExternalApplication!.id === $event.data.id) {
        this.closeDrawer();
      } else {
        this.switchExternalApplication($event.data);
      }
    }
  }

  switchUser(user: User) {
    if (this.userEdited && this.isEditMode) {
      this.showDiscardEditsDialog().show().done((dialogResult: any) => {
        if (dialogResult) {
          this.resetDrawer();
          this.selectedUser = user;
          this.editedUser = JSON.parse(JSON.stringify(this.selectedUser));
          this.selectedRowLinkedPartitionsOfUser = this.editedUser?.linkedPartitions;
          this.selectedRowUser = [this.selectedUser?.id];
          this.linkedPartitionsFiltered = this.partitions.filter(p => p.id !== this.selectedPartition?.id);
          this.isDrawerOpen = true;
        } else {
          this.selectedRowUser = [this.selectedUser!.id];
        }
      });
    } else {
      this.resetDrawer();
      this.selectedUser = user;
      this.editedUser = JSON.parse(JSON.stringify(this.selectedUser));
      this.selectedRowLinkedPartitionsOfUser = this.editedUser?.linkedPartitions;
      this.selectedRowUser = [this.selectedUser?.id];
      this.linkedPartitionsFiltered = this.partitions.filter(p => p.id !== this.selectedPartition?.id);
      this.isDrawerOpen = true;
    }

  }

  switchExternalApplication(externalApplication: ExternalApplication) {
    if (this.externalApplicationEdited && this.isEditMode) {
      this.showDiscardEditsDialog().show().done((dialogResult: any) => {
        if (dialogResult) {
          this.resetDrawer();
          this.selectedExternalApplication = externalApplication;
          this.editedExternalApplication = JSON.parse(JSON.stringify(this.selectedExternalApplication));
          this.selectedRowLinkedPartitionsOfExternalApplication = this.editedExternalApplication?.linkedPartitions;
          this.selectedRowExternalApplication = [this.selectedExternalApplication?.id];
          this.linkedPartitionsFiltered = this.partitions.filter(p => p.id !== this.selectedPartition?.id);
          this.isDrawerOpen = true;
        } else {
          this.selectedRowExternalApplication = [this.selectedExternalApplication!.id];
        }
      });
    } else {
      this.resetDrawer();
      this.selectedExternalApplication = externalApplication;
      if(!!this.selectedApiKey && !!this.apiLogsDateFrom && !!this.apiLogsDateTo) {
        this.loadApiCallsLog()
      }
      this.editedExternalApplication = JSON.parse(JSON.stringify(this.selectedExternalApplication));
      this.selectedRowLinkedPartitionsOfExternalApplication = this.editedExternalApplication?.linkedPartitions;
      this.selectedRowExternalApplication = [this.selectedExternalApplication?.id];
      this.linkedPartitionsFiltered = this.partitions.filter(p => p.id !== this.selectedPartition?.id);
      this.isDrawerOpen = true;
    }
  }

  /**
   * Call putUser ope with new user
   */
  createNewUser() {
    this.checkNewUserValidation();

    if (this.isNewFormValid)
      this.putUser(this.newUser);
  }

  /**
   * Call putUser ope with new externalApplication
   */
  createNewExternalApplication() {
    this.checkNewExternalApplication();
    if (this.isNewFormValid && !!this.newExternalApplication && !!this.newExternalApplicationApiConfig) {
      this.newExternalApplication.apiConfigMap = this.newExternalApplicationApiConfig;
      this.putExternalApplication(this.newExternalApplication);
    }
  }

  /**
   * Call putUser ope with edited user
   */
  saveUser() {
    this.isEditMode = false;
    this.selectionMode = 'none';
    this.updateUserTextOptions();

    this.putUser(this.editedUser);
  }

  /**
   * Call putUser ope with edited user
   */
  saveExternalApplication() {
    this.isEditMode = false;
    this.selectionMode = 'none';
    this.updateUserTextOptions();
    this.putExternalApplication(this.editedExternalApplication);
  }

  /**
   * Reset new user object
   */
  resetNewUser() {
    this.newUser = new User();
  }

  /**
   * Roll back edited user
   */
  resetEditedUser() {
    this.editedUser = JSON.parse(JSON.stringify(this.selectedUser));
    this.userEdited = false;
  }

  /**
   * Check if new user is valid, to enable SAVE button
   */
  checkNewUserValidation() {

    const result = this.newUserForm.instance.validate();

    this.isNewFormValid = result.isValid;
  }

  /**
   * Check if new user is valid, to enable SAVE button
   */
  checkNewExternalApplication() {
    const result = this.newExternalApplicationForm.instance.validate();

    this.isNewFormValid = result.isValid;
  }

  /**
   * Check if edited user is valid, to enable SAVE button
   */
  checkEditUserValidation() {

    if (!!this.editUserForm) {
      const result = this.editUserForm.instance.validate();

      this.isEditFormValid = result.isValid;

      this.sortLinkedPartitions();

      this.userEdited = JSON.stringify(this.editedUser) !== JSON.stringify(this.selectedUser);

      this.appService.setRegistryEntityIsChanged(this.userEdited && this.isEditMode);
    }
  }

  /**
   * Check if edited user is valid, to enable SAVE button
   */
  checkEditExternalApplicationValidation() {

    if (!!this.editExternalApplicationForm) {
      const result = this.editExternalApplicationForm.instance.validate();

      this.isEditFormValid = result.isValid;

      this.sortLinkedPartitions();

      this.externalApplicationEdited = JSON.stringify(this.editedExternalApplication) !== JSON.stringify(this.selectedExternalApplication);

      this.appService.setRegistryEntityIsChanged(this.externalApplicationEdited && this.isEditMode);
    }
  }


  sortLinkedPartitions() {
    if (!!this.selectedUser && !!this.editedUser) {
      this.selectedUser.linkedPartitions = this.selectedUser.linkedPartitions!.sort();
      this.editedUser.linkedPartitions = this.editedUser.linkedPartitions!.sort();
    }
    if (!!this.selectedExternalApplication && !!this.editedExternalApplication) {
      this.editedExternalApplication!.linkedPartitions = this.editedExternalApplication!.linkedPartitions!.sort();
      this.selectedExternalApplication!.linkedPartitions = this.selectedExternalApplication!.linkedPartitions!.sort();
    }
  }

  /**
   * Enable form edit in drawer
   */
  enableEditMode() {
    this.isEditMode = true;
    this.selectionMode = 'multiple';
    this.updateUserTextOptions();
  }

  /**
   * Disable form edit in drawer
   */
  disableEditMode() {
    if (this.isEditMode && (this.userEdited || this.externalApplicationEdited)) {
      this.showDiscardEditsDialog().show().done((dialogResult: any) => {
        if (dialogResult) {
          this.resetDrawer();
        }
      });
    } else {
      this.resetDrawer();
    }
  }

  /**
   * Show the edit parent dialog
   */
  showEditParentPartitionForm() {
    if (!!this.selectedUser) {
      this.selectedRowEditUserPartitionForm = [this.selectedUser!.partitionId];
      this.editUserPartition = true;
    }
    if (!!this.selectedExternalApplication) {
      this.selectedRowEditExternalApplicationPartitionForm = [this.selectedExternalApplication!.partitionId];
      this.editExternalApplicationPartition = true;
    }
  }

  /**
   * Show the new user dialog
   */
  showNewUserForm() {
    this.newUser = new User();
    this.linkedPartitionsFiltered = this.partitions.filter(p => p.id !== this.selectedPartition?.id);
    this.selectedRowPartitionNewUserForm = [];
    if (!!this.selectedPartition?.id) {
      this.selectedRowPartitionNewUserForm = [this.selectedPartition?.id];
      this.newUser!.partitionId = this.selectedPartition!.id;
    }
    // this.newUserForm.instance.repaint();
    this.newUser!.enabled = true;
    this.addUser = true;
  }

  /**
   * Show the new external application dialog
   */
  showNewExternalApplicationForm() {
    this.newExternalApplication = new ExternalApplication();
    if (!!this.gmService.eaApiConfigMapDefault) {
      this.selectedExternalApplicationApiConfigMapKeys = Object.keys(this.gmService.eaApiConfigMapDefault);
    }
    this.linkedPartitionsFiltered = this.partitions.filter(p => p.id !== this.selectedPartition?.id);
    this.newExternalApplicationApiConfig = structuredClone(this.gmService.eaApiConfigMapDefault);

    this.selectedRowPartitionNewExternalApplicationForm = [];
    if (!!this.selectedPartition?.id) {
      this.selectedRowPartitionNewExternalApplicationForm = [this.selectedPartition?.id];
      this.newExternalApplication!.partitionId = this.selectedPartition!.id;
    }
    // this.newUserForm.instance.repaint();
    this.newExternalApplication!.enabled = true;
    this.addExternalApplication = true;
  }

  /**
   * Update form fields when enabling/disabling edit mode
   */
  updateUserTextOptions() {
    if (!!this.editedUser) {
      this.userNewTextOptions = {
        valueChangeEvent: 'keyup',
      };

      this.userNewTextAreaOptions = {
        valueChangeEvent: 'keyup',
        autoResizeEnabled: true
      };

      this.userEditTextOptions = {
        valueChangeEvent: 'keyup',
        disabled: !this.isEditMode
      };

      this.userEditPasswordOptions = {
        valueChangeEvent: 'keyup',
        disabled: !this.isEditMode,
        mode: this.passwordMode,
        buttons: [
          {
            name: 'password',
            location: 'after',
            options: {
              icon: 'eyeopen',
              stylingMode: 'text',
              onClick: () => {
                this.passwordMode = this.passwordMode === 'text' ? 'password' : 'text';
                this.updateEditPasswordMode();
              },
            }
          }
        ]
      };

      this.userEditTextAreaOptions = {
        valueChangeEvent: 'keyup',
        disabled: !this.isEditMode,
        autoResizeEnabled: true
      };

      this.userEditCheckBoxOptions = {
        disabled: !this.isEditMode
      };

      this.userEditSwitchOptions = {
        disabled: !this.isEditMode
      };
    }

    if (!!this.editedExternalApplication) {
      this.externalApplicationEditTextOptions = {
        valueChangeEvent: 'keyup',
        disabled: !this.isEditMode
      };
      this.externalApplicationEditSwitchOptions = {
        switchedOnText: 'ON',
        switchedOffText: 'OFF',
        valueChangeEvent: 'keyup',
        disabled: !this.isEditMode
      };

      this.requestLimitEditOptions = {
        min: 0,
        showSpinButtons: true,
        valueChangeEvent: 'keyup',
        disabled: !this.isEditMode
      };

      this.arraySizeEditOptions = {
        min: 0,
        placeholder: 0,
        showSpinButtons: true,
        valueChangeEvent: 'keyup',
        disabled: !this.isEditMode
      };
    }
  }

  /**
   * Change password field type to show/hide text
   */
  updatePasswordMode() {
    this.userPasswordOptions = {
      valueChangeEvent: 'keyup',
      mode: this.passwordMode,
      buttons: [
        {
          name: 'password',
          location: 'after',
          options: {
            icon: 'eyeopen',
            stylingMode: 'text',
            onClick: () => {
              this.passwordMode = this.passwordMode === 'text' ? 'password' : 'text';
              this.updatePasswordMode();
            },
          }
        }
      ]
    }
  }
  /**
   * Change password field type to show/hide text
   */
  updateEditPasswordMode() {
    this.userEditPasswordOptions = {
      valueChangeEvent: 'keyup',
      disabled: !this.isEditMode,
      mode: this.passwordMode,
      buttons: [
        {
          name: 'password',
          location: 'after',
          options: {
            icon: 'eyeopen',
            stylingMode: 'text',
            onClick: () => {
              this.passwordMode = this.passwordMode === 'text' ? 'password' : 'text';
              this.updateEditPasswordMode();
            },
          }
        }
      ]
    }
  }

  /**
   * Ope to delete a user
   */
  deleteUser() {

    // close delete user dialog
    this.deletingUser = false;

    // create cb
    const cb: DelUserCB = new DelUserCB();
    cb.i.id = this.selectedUser!.id;

    // call ope
    this.userService.delUser(cb).then((_) => {
      this.toastService.openSuccessToastMessage(this.translate.instant("REGISTRY.USER.TEXT.DELETED"));
      this.getUsers();
      this.getExternalApplications();
      this.isDrawerOpen = false;
      this.selectedUser = undefined;
    });
  }

  deleteExternalApplication() {

    // close delete user dialog
    this.deletingExternalApplication = false;

    // create cb
    const cb: DelExternalApplicationCB = new DelExternalApplicationCB();
    if (!!this.selectedExternalApplication && !!this.selectedExternalApplication.id) {
      cb.i.id = this.selectedExternalApplication!.id;
    }

    // call ope
    this.externalApplicationService.delExternalApplication(cb).then((_) => {
      this.toastService.openSuccessToastMessage(this.translate.instant("REGISTRY.USER.TEXT.DELETED"));
      this.getUsers();
      this.getExternalApplications();
      this.isDrawerOpen = false;
      this.selectedExternalApplication = undefined;
    });
  }

  changeExternalApplicationSecretKey() {
    // create cb
    const cb: ChangeExternalApplicationSecretCB = new ChangeExternalApplicationSecretCB();
    if (!!this.selectedExternalApplication && !!this.selectedExternalApplication.id) {
      cb.i.id = this.selectedExternalApplication!.id;
    }

    // call ope
    this.externalApplicationService.changeExternalApplicationSecret(cb).then(() => {
      this.toastService.openSuccessToastMessage(this.translate.instant("REGISTRY.EXTERNAL_APPLICATION.TEXT.UPDATED"))
      this.changingSecretKey = false;
    });
  }

  onSelectNewUserPartitionClick($event: any) {
    this.newUser!.linkedPartitions = $event.selectedRowKeys ?? [];
  }

  repaintNewUserPartitionTree(): void {
    this.newUserPartitionTree?.instance?.repaint();
  }

  onSelectNewExternalApplicationPartitionClick($event: any) {
    this.newExternalApplication!.linkedPartitions = $event.selectedRowKeys ?? [];
  }

  onSelectEditUserPartitionClick($event: any) {
    if (!($event.event.target.parentElement.classList.contains("dx-treelist-expanded") || $event.event.target.parentElement.classList.contains("dx-treelist-collapsed"))) {
      if ($event.data.id != this.editedUser!.partitionId)
        this.editedUser!.partitionId = $event.data.id;
    }
  }

  onSelectEditExternalApplicationPartitionClick($event: any) {
    if (!($event.event.target.parentElement.classList.contains("dx-treelist-expanded") || $event.event.target.parentElement.classList.contains("dx-treelist-collapsed"))) {
      if ($event.data.id != this.editedExternalApplication!.partitionId)
        this.editedExternalApplication!.partitionId = $event.data.id;
    }
  }

  closeEditUserPartitionForm() {
    this.editUserPartition = false;
    this.editedUser = JSON.parse(JSON.stringify(this.selectedUser));
  }

  closeEditExternalApplicationPartitionForm() {
    this.editExternalApplicationPartition = false;
    this.editedExternalApplication = JSON.parse(JSON.stringify(this.selectedExternalApplication));
  }

  updateUserPartition() {


    const cb: UpdateUserPartitionCB = new UpdateUserPartitionCB();

    cb.i.userId = this.editedUser!.id;
    cb.i.newPartitionId = this.editedUser!.partitionId!;

    this.userService.updateUserPartition(cb).then((_) => {
      this.editUserPartition = false;
      this.isDrawerOpen = false;
      this.selectedUser = undefined;
      this.editedUser = undefined;
      this.toastService.openSuccessToastMessage(this.translate.instant("REGISTRY.USER.TEXT.UPDATED"));
      this.getUsers();
      this.getExternalApplications();
    });
  }

  updateExternalApplicationPartition() {
    const cb: UpdateExternalApplicationCB = new UpdateExternalApplicationCB();

    if (!!this.editedExternalApplication?.id) {
      cb.i.id = this.editedExternalApplication!.id;
    }
    cb.i.passedPartitionId = this.editedExternalApplication!.partitionId!;

    this.externalApplicationService.updateExternalApplicationPartition(cb).then((_) => {
      this.editExternalApplicationPartition = false;
      this.isDrawerOpen = false;
      this.selectedExternalApplication = undefined;
      this.editedExternalApplication = undefined;
      this.toastService.openSuccessToastMessage(this.translate.instant("REGISTRY.EXTERNAL_APPLICATION.TEXT.UPDATED"));
      this.getUsers();
      this.getExternalApplications();
    });
  }

  checkIfUserPartitionChanged() {
    console.log(this.editedUser?.partitionId)
    return this.editedUser?.partitionId !== this.selectedUser?.partitionId;
  }

  checkIfExternalApplicationPartitionChanged() {
    console.log(this.editedExternalApplication?.partitionId)
    return this.editedExternalApplication?.partitionId !== this.selectedExternalApplication?.partitionId;
  }

  isNodeSelected = (node: any) => {
    if (!!node)
      return this.editedUser!.linkedPartitions!.includes(node.id);
    return false;
  };

  getNoDataText() {
    if (!this.selectedPartition)
      this.noDataText = 'Seleziona una partizione';

    if (!!this.selectedPartition && this.users.length == 0)
      this.noDataText = 'Nessun utente trovato per questa partizione';

    this.noDataText = '';
  }

  printLocaleText(locale: string): string {
    if (locale === 'it') {
      return 'Italiano';
    } else if (locale === 'en') {
      return 'English';
    } else if (locale === 'de') {
      return 'Deutsch';
    } else if (locale === 'es') {
      return 'Español';
    } else if (locale === 'fr') {
      return 'Français';
    }
    return locale;
  }

  updateLinkedPartitions($event: SelectionChangedEvent) {
    if (this.selectionMode !== "none" && !!this.editedUser) {
      this.editedUser.linkedPartitions! = $event.selectedRowKeys;
    }
    if (this.selectionMode !== "none" && !!this.editedExternalApplication) {
      this.editedExternalApplication.linkedPartitions! = $event.selectedRowKeys;
    }
  }

  getApiConfig(apiKey: string) {
    return this.editedExternalApplication?.apiConfigMap?.[apiKey];
  }

  getDefaultApiConfig(apiKey: string) {
    return this.newExternalApplicationApiConfig?.[apiKey];
  }

  loadApiCallsLog() {
    this.getExternalApplicationApiCallsLog(this.selectedApiKey, this.apiLogsDateFrom, this.apiLogsDateTo);
  }


  fromValidationRules: ValidationRule[] = [
    {type: 'required', message: 'From date is required'},
    {
      type: 'custom',
      reevaluate: true,
      validationCallback: () => {
        if (!this.apiLogsDateFrom || !this.apiLogsDateTo) return true;
        return this.apiLogsDateFrom <= this.apiLogsDateTo;
      },
      message: '"From" date cannot be later than "To" date'
    }
  ];

  toValidationRules: ValidationRule[] = [
    {type: 'required', message: 'To date is required'},
    {
      type: 'custom',
      reevaluate: true,
      validationCallback: () => {
        if (!this.apiLogsDateFrom || !this.apiLogsDateTo) return true;
        return this.apiLogsDateTo >= this.apiLogsDateFrom;
      },
      message: '"To" date cannot be earlier than "From" date'
    }
  ];

  apiLogsConfigurationsChanged() {
    setTimeout(() => {
      // Clear validation state without resetting values
      this.dateFromBox?.instance.option('isValid', true);
      this.dateToBox?.instance.option('isValid', true);

      // Now validate
      const result = this.validationGroup?.instance.validate();

      if (result?.isValid && this.selectedApiKey) {
        this.loadApiCallsLog();
      }
    }, 0);
  }

  private getDefaultApiNames() {
  }

  onUserActionClick(action: string) {
    switch (action) {
      case 'sendWelcomeEmail':
        this.sendingWelcomeEmail = true;
        break;
      case 'resetPassword':
        this.resettingPassword = true;
        break;
      case 'impersonate':
        this.impersonateUser();
        break;
      case 'revokeSessions':
        this.revokingSessions = true;
        break;
      case 'changePartition':
        this.showEditParentPartitionForm();
        break;
    }
  }

  impersonateUser() {
    if (this.selectedUser) {
      const cb = new ImpersonateUserCB();
      cb.i.userId = this.selectedUser.id;
      this.authenticationOpeService.impersonateUser(cb)
        .then(() => {
          this.ngZone.runOutsideAngular(() => {
            this.authorizationOPEService.startImpersonation(cb.o.access_token);
            window.location.href = '/';
          });
        });
    }
  }

}
